<div class="raptor-email-quote-interstitial flex flex-column form-typography">
  <div class="raptor-email-quote-interstitial-button margin-bottom-xsmall text-right">
    <button mat-button type="button" class="padding-none raptor-email-quote-close-button" (click)="onCloseClick()">
      <mat-icon class="clear" aria-hidden="false" aria-label="close"></mat-icon>
    </button>
  </div>

  <div class="raptor-email-quote-interstitial-form grid">
    <div class="cell cell-large-col-span-12 cell-medium-col-span-8">
      <h1 class="margin-bottom-xmedium">Email my quote</h1>
      <div class="margin-bottom-xmedium subtext">Enter your email address below and we’ll send you a link so you can finish your quote whenever you like. We’ll save all the information you’ve entered so your price won’t change</div>

      <div class="raptor-email-quote-input-container margin-bottom-xmedium">
        <div class="text-left">
          <label class="block margin-bottom-xxsmall">Email</label>
          <mat-form-field appearance="outline" class="width-full">
            <input matInput [formControl]="emailToQuote" type="email" />
          </mat-form-field>
          <mat-error *ngIf="submittedQuote && emailToQuote.invalid">
            Please enter a valid email address
          </mat-error>
        </div>
      </div>

      <div *ngIf="quoteMessage" class="open-form-info padding-medium margin-bottom-xmedium">
        <div>
          <p [innerHTML]="quoteMessage"></p>
        </div>
      </div>

      <button
        mat-flat-button
        color="primary"
        class="raptor-email-quote-send-button"
        type="button"
        [disabled]="sendingQuote"
        (click)="onSendQuoteClick()">
        Send my quote
      </button>
    </div>
  </div>
</div>
